<template>
	<div style="display: inline-block;margin: 10px;position: relative;">
		<!-- :style="[{color: `${ color }`}]" -->
		<template v-if="uploadType == 1">
			<div class="btn" style="user-select: none;text-align: center;line-height: 32px;border-radius: 2px; border: 1px solid #E6E6E6; padding-left: 5px;padding-right: 5px;
      cursor: pointer;"
				:style="[{width: `${ width }`},{height: `${ height }`},{color: `${ color }`},{ fontSize: `${ fontSize }` },{backgroundColor: `${ backgroundColor }`}]"
				@click="btnclick">
				<slot></slot>
				<img v-if="src" :src="src" style="width: 16px;height: 16px;vertical-align: middle;" />
				{{ title }}
			</div>
			<div :style="[{ width: `${ opwidth }` , top: `${ top }` }]" class="bodis" v-if="optional">
			</div>
			<input ref="filElem" id="filElem" accept=".xls,.xlsx" type="file" class="upload-file" @change="getFile"
				style="display: none;" v-if="types=='file'">
			<input ref="filElem" id="filElem" accept=".xls,.xlsx,.ppt" type="file" multiple="multiple"
				class="upload-file" @change="getFiles" style="display: none;" v-if="types=='files'">
			<input ref="filElem" id="filElem" accept=".png,.jpg" type="file" class="upload-file" @change="getFile"
				style="display: none;" v-if="types=='fileImg'">
			<input ref="filElem" id="filElem" accept=".png,.jpg" multiple="multiple" type="file" class="upload-file"
				@change="getFiles" style="display: none;" v-if="types=='multiple'">
			<input ref="filElem" id="filElem" accept=".pdf" multiple="multiple" type="file" class="upload-file"
				@change="getFiles" style="display: none;" v-if="types=='multiplePDF'">
			<input ref="filElem" id="filElem" accept="*" type="file" class="upload-file" @change="getFile"
				style="display: none;" v-if="types=='UploadAll'">
		</template>
		<template v-if="uploadType == 2">
			<div class="btn" style="user-select: none;text-align: left;line-height: 32px; 
      cursor: pointer;border:none;"
				:style="[{width: `${ width }`},{height: `${ height }`},{color: `${ color }`},{ fontSize: `${ fontSize }` },{backgroundColor: `${ backgroundColor }`}]"
				@click="btnclick">
				<slot></slot>
				<img v-if="src" :src="src" style="width: 16px;height: 16px;vertical-align: middle;" />
				{{ title }}
			</div>
			<div :style="[{ width: `${ opwidth }` , top: `${ top }` }]" class="bodis" v-if="optional">
			</div>
			<input ref="filElem" id="filElem" accept=".xls,.xlsx" type="file" class="upload-file" @change="getFile"
				style="display: none;" v-if="types=='file'">
			<input ref="filElem" id="filElem" accept=".xls,.xlsx,.ppt" type="file" multiple="multiple"
				class="upload-file" @change="getFiles" style="display: none;" v-if="types=='files'">
			<input ref="filElem" id="filElem" accept=".png,.jpg,.pdf" type="file" class="upload-file" @change="getFile"
				style="display: none;" v-if="types=='fileImg'">
			<input ref="filElem" id="filElem" accept=".png,.jpg" multiple="multiple" type="file" class="upload-file"
				@change="getFiles" style="display: none;" v-if="types=='multiple'">
			<input ref="filElem" id="filElem" accept=".pdf" multiple="multiple" type="file" class="upload-file"
				@change="getFiles" style="display: none;" v-if="types=='multiplePDF'">
			<input ref="filElem" id="filElem" accept="*" multiple="multiple" type="file" class="upload-file"
				@change="getFiles" style="display: none;" v-if="types=='UploadAll'">
		</template>
		<template v-if="uploadType == 3">
			<div class="aclick" style="cursor: pointer;width:56px;" :style="[{ color: `${ color }`}]" @click="btnclick">
				{{ title }}
			</div>
			<div :style="[{ width: `${ opwidth }` , top: `${ top }` }]" class="bodis" v-if="optional">
			</div>
			<input ref="filElem" id="filElem" accept=".xls,.xlsx" type="file" class="upload-file" @change="getFile"
				style="display: none;" v-if="types=='file'">
			<input ref="filElem" id="filElem" accept=".xls,.xlsx,.ppt" type="file" multiple="multiple"
				class="upload-file" @change="getFiles" style="display: none;" v-if="types=='files'">
			<input ref="filElem" id="filElem" accept=".png,.jpg" type="file" class="upload-file" @change="getFile"
				style="display: none;" v-if="types=='fileImg'">
			<input ref="filElem" id="filElem" accept=".png,.jpg" multiple="multiple" type="file" class="upload-file"
				@change="getFiles" style="display: none;" v-if="types=='multiple'">
			<input ref="filElem" id="filElem" accept=".pdf" multiple="multiple" type="file" class="upload-file"
				@change="getFiles" style="display: none;" v-if="types=='multiplePDF'">
			<input ref="filElem" id="filElem" accept="*" multiple="multiple" type="file" class="upload-file"
				@change="getFiles" style="display: none;" v-if="types=='UploadAll'">
		</template>
	</div>
</template>

<script>
	export default {
		props: {
			//文字颜色
			color: {
				type: String,
				default: '#000'
			},
			// 按钮宽度
			width: {
				type: String,
				default: '100%'
			},
			// 按钮高度
			height: {
				type: String,
				default: '32px'
			},
			// 按钮文本
			title: {
				type: String,
				default: ''
			},
			// 文字大小
			fontSize: {
				type: String,
				default: '2px'
			},
			// 按钮背景色
			backgroundColor: {
				type: String,
				default: '#E6E6E6'
			},
			// icon路径
			src: {
				type: String,
				default: ''
			},
			// 控制也用和禁用
			optional: {
				type: Boolean,
				default: false
			},
			// 禁用蒙版的宽度
			opwidth: {
				type: String,
				default: '68px'
			},
			// 禁用蒙版的定位
			top: {
				type: String,
				default: '222px'
			},
			types: {
				type: String,
				default: 'file'
			},
			uploadType: {
				type: Number,
				default: 1
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			btnclick() {
				this.$refs.filElem.dispatchEvent(new MouseEvent('click'))
			},
			getFile(e) {
				const inputFile = e.target.files[0];
				this.$emit('getFile', inputFile)
				// input[file]标签防重复问题
				e.target.value = ""
			},
			getFiles(e) {
				const inputFile = e.target.files;
				this.$emit('getFiles', inputFile)
				// input[file]标签防重复问题
				e.target.value = ""
			},
		}
	}
</script>

<style lang="less">
	.bodis {
		// width: 68px;
		height: 34px;
		opacity: 0.5;
		background-color: #ffffff;
		// background-color: red;
		position: absolute;
		// top: 216px;
		cursor: no-drop;
		//   position: relative;
		//   top: -416px;
		z-index: 1000;
		user-select: none;
	}

	.btn:hover {
		background-color: #f9f9f9 !important;
	}

	.btn:active {
		background-color: #f3f3f3 !important;
	}

	.aclick {
		display: inline-block;
		font-size: 14px;
		color: #333333;
		text-decoration: underline;
		cursor: pointer;
		text-align: center;
	}
</style>